import React, { Component } from 'react';
import ReportDialog from './ReportDialog';
import { REPORT_HEADINGS } from './constants';
import { submitReport } from '../../lib/api';
import { track } from '@amplitude/analytics-browser';

class Report extends Component {
  state = {
    open: false,
    selected: '',
    subject: '',
    body: {
      message:'',
      testId: this.props.testId,
      questionId: this.props.questionId,
      optionId: '',
      subject: null
    },
    attachments:null
  }
  render() {
    let { open } = this.state;
    return (
      <>
        <img onClick={() => this.handleModalToggle()} style={{ color: 'white', width: '20px', height: '18px' }} src="/images/Report.svg"></img>
        {/* <span onClick={() => this.handleModalToggle()}>Report</span> */}
        <ReportDialog handleSubmit={this.handleSubmit} onInputChange={this.onInputChange} headings={REPORT_HEADINGS} selected={this.state.selected} onChange={this.onReportOptionChange} dialogTitle="Report" open={open} handleModalToggle={this.handleModalToggle}></ReportDialog>
      </>
    );
  }

  onReportOptionChange = (reportOption) => {
    this.setState({ selected: reportOption });
  }

  handleSubmit=()=>{
    this.submitReport();
  }

  onInputChange=(value, key)=> {
    let body = this.state.body;
    body[key] = value;
    this.setState({
      body: body
    });
  }

  handleModalToggle = () => {
    if (this.state.open) {
      this.setState({ open: false });
    } else this.setState({ open: true,selected:''});
  }

  submitReport = async () => {
    console.log(this.state)
    try {

      const issue = this.state.body.subject && this.state.body.subject != '' ? this.state.body.subject : this.state.selected;

      let data = {
        content_id: this.state.body.questionId,
        category_id: 4,
        issue: issue,
        comments: this.state.body.message,
        device: localStorage.getItem('device')
      }
      await submitReport(data);
      this.setState({ 
        open: false,    
        body: {
          message:'',
          testId: this.props.testId,
          questionId: this.props.questionId,
          optionId: '',
          subject: null
        },
      });

      // Amplitude Tracking
      const eventProperties = {...data,
        screen_name : 'test',
        type : 'question',
        test_id : this.props.testId,
      }
        track('report_clicked',eventProperties);
    } catch (error) {
      this.setState({ open: false });
      console.log(error);
    }
  }
}

export default Report;